export default __webpack_public_path__ + "static/media/hero.7d052373.png";